import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export function ProductCard({ item, index = 0, testid }) {
  return (
    <Reveal delay={(index % 4) * 0.06} className="group flex flex-col border border-[#E3E8EF] bg-white transition-[box-shadow,transform] duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_rgba(14,34,56,0.10)]" data-testid={testid}>
      <div className="relative overflow-hidden">
        <img src={item.img} alt={item.alt || item.desc || `${item.name || item.part} component`} loading="lazy"
          className="h-52 w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        {item.tag && <span className="absolute left-3 top-3 bg-amber px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-maintext">{item.tag}</span>}
        {item.part && <span className="absolute left-3 top-3 bg-ink px-2.5 py-1 text-[11px] font-semibold tracking-wider text-white">{item.part}</span>}
      </div>
      <div className="flex flex-1 flex-col p-6">
        {item.category && <span className="text-[11px] font-semibold uppercase tracking-widest text-amber-hover">{item.category}</span>}
        <h3 className="mt-1 font-display uppercase text-xl tracking-wide text-ink">{item.name || item.model}</h3>
        {item.model && item.part && <p className="text-xs text-muted">Compatible: {item.model}</p>}
        <p className="mt-2 flex-1 text-sm leading-relaxed text-muted">{item.desc}</p>
        <Link to={item.part ? "/request-a-quote" : "/parts"} className="mt-5 inline-flex items-center gap-2 font-body text-sm font-semibold text-ink hover:text-amber-hover transition-colors" data-testid={testid ? `${testid}-enquire` : undefined}>
          {item.part ? "Enquire" : "View Parts"} <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
        </Link>
      </div>
    </Reveal>
  );
}
